import { URL_API } from "@/config";
import { tokenDecrypted } from "@/utils/decryptToken";
import { url } from "@/utils/urlParam";
import axios from "axios";

export async function getTask({
  companyId,
  page,
  limit,
  createdDate,
  departementId,
  employeeId,
  status,
}) {
  try {
    const params = new URLSearchParams(url.search);
    params.append("page", page);
    params.append("limit", limit);
    if (companyId) {
      params.append("company_id", companyId);
    }

    if (createdDate.length) {
      params.append("created_date", [createdDate]);
    }

    if (departementId !== "") {
      params.append("departement_id", departementId);
    }

    if (employeeId !== "") {
      params.append("employee_id", employeeId);
    }

    if (status !== "") {
      params.append("status", status);
    }

    const { data } = await axios.get(`${URL_API}/tasks?${params.toString()}`, {
      headers: {
        Authorization: `Bearer ${tokenDecrypted()}`,
      },
    });

    return {
      success: true,
      message: "",
      data: data.data,
      code: 200,
      meta: data.meta,
    };
  } catch (error) {
    return {
      success: false,
      code: error.response.status,
      message: error.response.statusText,
      data: [],
    };
  }
}

export async function createTask(payload) {
  try {
    const { data } = await axios.post(`${URL_API}/tasks`, payload, {
      headers: {
        Authorization: `Bearer ${tokenDecrypted()}`,
      },
    });

    return {
      success: true,
      message: data.message,
      data: data.data,
      code: 200,
    };
  } catch (error) {
    return {
      success: false,
      code: error.response.status,
      message: error.response.statusText,
      data: [],
      errors: error.response.data.errors,
    };
  }
}

export async function updateTask({ id, payload }) {
  try {
    const { data } = await axios.put(`${URL_API}/tasks/${id}`, payload, {
      headers: {
        Authorization: `Bearer ${tokenDecrypted()}`,
      },
    });

    return {
      success: true,
      message: data.message,
      code: 200,
    };
  } catch (error) {
    return {
      success: false,
      code: error.response.status,
      message: error.response.statusText,
      data: [],
      errors: error.response.data.errors,
    };
  }
}

export async function deleteTask(id) {
  try {
    await axios.delete(`${URL_API}/tasks/${id}`, {
      headers: {
        Authorization: `Bearer ${tokenDecrypted()}`,
      },
    });

    return {
      success: true,
      message: "",
      code: 200,
    };
  } catch (error) {
    return {
      success: false,
      code: error.response.status,
      message: error.response.statusText,
    };
  }
}
